import { render } from "./CardFight.vue?vue&type=template&id=262978f6&scoped=true"
import script from "./CardFight.vue?vue&type=script&lang=js"
export * from "./CardFight.vue?vue&type=script&lang=js"

import "./CardFight.vue?vue&type=style&index=0&id=262978f6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-262978f6"]])

export default __exports__